// @flow
import { KEY } from './constants'

export const getAccounts = (state: Object) => state[KEY].accounts
export const getContacts = (state: Object) => state[KEY].contacts
